/**
 * Error handling utilities
 */

// Error types
export const ERROR_TYPES = {
  NETWORK: 'network',
  VALIDATION: 'validation',
  AUTHENTICATION: 'authentication',
  NOT_FOUND: 'not_found',
  SERVER: 'server',
  UNKNOWN: 'unknown'
};

// Parse error and return user-friendly message
export const parseError = (error) => {
  // Firebase errors
  if (error.code) {
    switch (error.code) {
      case 'auth/email-already-in-use':
        return { type: ERROR_TYPES.VALIDATION, message: 'This email is already registered' };
      case 'auth/invalid-email':
        return { type: ERROR_TYPES.VALIDATION, message: 'Invalid email address' };
      case 'auth/weak-password':
        return { type: ERROR_TYPES.VALIDATION, message: 'Password is too weak' };
      case 'auth/user-not-found':
        return { type: ERROR_TYPES.AUTHENTICATION, message: 'No account found with this email' };
      case 'auth/wrong-password':
        return { type: ERROR_TYPES.AUTHENTICATION, message: 'Incorrect password' };
      case 'auth/too-many-requests':
        return { type: ERROR_TYPES.AUTHENTICATION, message: 'Too many failed attempts. Please try again later' };
      case 'auth/network-request-failed':
        return { type: ERROR_TYPES.NETWORK, message: 'Network error. Please check your connection' };
      case 'auth/user-disabled':
        return { type: ERROR_TYPES.AUTHENTICATION, message: 'This account has been disabled' };
      default:
        return { type: ERROR_TYPES.AUTHENTICATION, message: error.message };
    }
  }

  // Network errors
  if (error.message === 'Network Error' || !navigator.onLine) {
    return { type: ERROR_TYPES.NETWORK, message: 'No internet connection. Please check your network' };
  }

  // HTTP errors
  if (error.response) {
    const status = error.response.status;
    switch (status) {
      case 404:
        return { type: ERROR_TYPES.NOT_FOUND, message: 'The requested resource was not found' };
      case 500:
        return { type: ERROR_TYPES.SERVER, message: 'Server error. Please try again later' };
      case 401:
        return { type: ERROR_TYPES.AUTHENTICATION, message: 'You need to be logged in to perform this action' };
      case 403:
        return { type: ERROR_TYPES.AUTHENTICATION, message: 'You don\'t have permission to perform this action' };
      default:
        return { type: ERROR_TYPES.UNKNOWN, message: 'An unexpected error occurred' };
    }
  }

  // Default error
  return { 
    type: ERROR_TYPES.UNKNOWN, 
    message: error.message || 'An unexpected error occurred. Please try again' 
  };
};

// Log error to console (in production, send to error tracking service)
export const logError = (error, context = {}) => {
  console.error('Error:', {
    message: error.message,
    stack: error.stack,
    context,
    timestamp: new Date().toISOString()
  });
  
  // In production, send to error tracking service like Sentry
  // if (process.env.NODE_ENV === 'production') {
  //   Sentry.captureException(error, { extra: context });
  // }
};

// Handle async errors with automatic parsing
export const handleAsyncError = async (asyncFn, context = {}) => {
  try {
    return { data: await asyncFn(), error: null };
  } catch (error) {
    logError(error, context);
    return { data: null, error: parseError(error) };
  }
};
